/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import { queryString } from '@utils/format';

export const state = {
  m_jenjangs: [],
  psp_peringkat: {},
  tutup_konfirmasi: '',
  validasi: null,
};

export const mutations = {
  SET_M_JENJANGS(state, newValue) {
    state.m_jenjangs = newValue ?? {};
  },
  SET_PSP_PERINGKAT(state, newValue) {
    state.psp_peringkat = newValue ?? {};
  },
  SET_TUTUP_KONFIRMASI(state, newValue) {
    state.tutup_konfirmasi = newValue ?? '';
  },
  SET_VALIDASI(state, newValue) {
    state.validasi = newValue ?? '';
  },
};

export const actions = {
  async index({ commit, rootState }) {
    const id = rootState.auth.instansi_id;
    const data = await http.get(`psp/i/${id}/peringkat`).then(({ data }) => data);

    commit('SET_PSP_PERINGKAT', data.psp_peringkat ?? {});
    commit('SET_M_JENJANGS', data.m_jenjangs ?? {});
    commit('SET_TUTUP_KONFIRMASI', data['tutup-selesai'] ?? '');
    commit('SET_VALIDASI', data['validasi'] ?? '');

    return data;
  },

  async fetch({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    let index = 'peringkat';

    if (payload.attr && payload.attr.action) {
      index += `-${payload.attr.action}`;
    }

    if (payload.attr && payload.attr.id) {
      index += `/${payload.attr.id}`;
    }

    if (payload.attr && payload.attr.type) {
      index += `/${payload.attr.type}`;
    }

    return await http.get(`psp/i/${id}/${index}?${queryString(payload.params)}`).then(({ data }) => data);
  },

  async detail({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    let index = 'peringkat';

    if (payload.action) {
      index += `-${payload.action}`;
    }

    if (payload.id) {
      index += `/${payload.id}`;
    }

    const { data, validasi } = await http.get(`psp/i/${id}/${index}`);
    return Promise.resolve(data, validasi);
  },

  save({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    let index = 'peringkat';

    if (payload.action) {
      index += `-${payload.action}`;
    }

    if (payload.id) {
      index += `/${payload.id}`;
    }

    if (payload.upload) {
      return http
        .post(`psp/i/${id}/${index}/${payload.type || 'save'}`, payload.params, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(({ data }) => data);
    }

    return http.post(`psp/i/${id}/${index}/${payload.type || 'save'}`, payload.params).then(({ data }) => data);
  },

  download({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    let index = 'peringkat';

    if (payload.action) {
      index += `-${payload.action}`;
    }

    if (payload.id) {
      index += `/${payload.id}`;
    }

    if (payload.type) {
      index += `/${payload.type}`;
    }

    const url = `${process.env.VUE_APP_API_URL}/psp/i/${id}/${index}?${queryString(payload.params)}`;
    return Promise.resolve(url);
  },
};
